export enum FeeTimeRepetitionAmountType {
  Set = 1,
  Percent = 2,
  FixedForQuantity = 3
}
